import angular from 'angular';

import tszPriceCalculator from './tsz-price-calculator';

const tszPriceCalculatorModule = angular.module('tsz.components.tszPriceCalculator', [])
  .component('tszPriceCalculator', tszPriceCalculator);

export default tszPriceCalculatorModule;



// WEBPACK FOOTER //
// ./src/components/tsz-price-calculator/tsz-price-calculator.module.js